import { gsap, Power4 } from "gsap";

class DropDown {
  constructor(el) {
    this.dom = {el: el};
    // this.dom.trigger = this.dom.el.querySelectorAll('[data-js="dropdown-trigger"]')

    this.path = {
      reset: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
      open: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
      close: 'polygon(100% 0, 100% 0, 100% 100%, 100% 100%)'
    }
    
    this.init();
  }
  
  isSP() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  closePopup() {
    const container = this.dom.el.querySelector('[data-js="dropdown-container"]')
    if (container) {
      container.classList.remove('is-open')
    }
  }

  initPopup() {
    const popup = this.dom.el.querySelector('[data-js="dropdown-popup"]')
    if (!popup) return;

    popup.addEventListener('click', (e) => {
      if (!this.isSP()) return;
      e.stopPropagation();

      const container = this.dom.el.querySelector('[data-js="dropdown-container"]')
      if (!container) return;

      const isOpen = container.classList.contains('is-open')

      document.querySelectorAll('[data-js="dropdown-container"]').forEach(el => {
        el.classList.remove('is-open')
      })

      if (!isOpen) {
        container.classList.add('is-open')
      }
    })

    // document.addEventListener('click', () => {
    //   if (!this.isSP()) return;
    //   this.closePopup();
    // })

    document.addEventListener('scroll', () => {
      if (!this.isSP()) return;
      this.closePopup();
    }, { passive: true })
  }

  init() {
    this.initPopup();

    this.dom.el.addEventListener('mouseenter', (e) => {
      const container = e.currentTarget.querySelector('[data-js="dropdown-container"]')
      // const inner = e.currentTarget.querySelector('[data-js="dropdown-inner"]')
      // const wrapper = e.currentTarget.querySelector('[data-js="dropdown-wrapper"]')

      gsap.set(container, {
        zIndex: 100
      })


      // gsap.fromTo(container, {
      //   clipPath: this.path.reset,
      // }, {
      //   clipPath: this.path.open,
      //   duration: .3,
      //   // delay: .1,
      //   ease: Power4.easeInOut,
      // })
      // gsap.fromTo(wrapper, {
      //   opacity: 0,
      //   translateY: '1.25rem',
      // }, {
      //   opacity: 1,
      //   translateY: 0,
      //   duration: .45,
      //   // delay: .2,
      //   ease: 'none',
      // })
      // gsap.set(this.dom.trigger, {
      //   zIndex: 1000
      // })
    })

    this.dom.el.addEventListener('mouseleave', (e) => {
      const container = e.currentTarget.querySelector('[data-js="dropdown-container"]')
      // const inner = e.currentTarget.querySelector('[data-js="dropdown-inner"]')
      // const wrapper = e.currentTarget.querySelector('[data-js="dropdown-wrapper"]')

      gsap.set(container, {
        zIndex: 0
      })

      // gsap.fromTo(container, {
      //   clipPath: this.path.open,
      // }, {
      //   clipPath: this.path.close,
      //   duration: .6,
      //   ease: Power4.easeIn,
      //   delay: 0,
      //   onComplete: () => {
      //     gsap.set(container, {
      //       clipPath: this.path.open,
      //     })
      //     gsap.set(inner, {
      //       clipPath: this.path.reset,
      //     })
      //     gsap.set(this.dom.trigger, {
      //       zIndex: 0
      //     })
      //   }
      // })
      // gsap.to(wrapper, {
      //   opacity: 0,
      //   duration: .3,
      //   ease: 'none',
      //   // delay: .3,
      //   onComplete: () => {
      //     gsap.set(wrapper, {
      //       translateY: '1.25rem',
      //     })
      //   }
      // })
    })
  }
}

export default DropDown